document.querySelectorAll('.testimonials__carousel').forEach((carousel) => {
    const swiperEl = carousel.querySelector('.testimonials__swiper');
    if (!swiperEl) return;

    new Swiper(swiperEl, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
            576: {
                slidesPerView: 1.15,
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
        },
        pagination: {
            el: carousel.querySelector('.testimonials__pagination'),
            clickable: true,
        },
    });
});
